/* Retrovisor mix — interações das seções cl-rv-* */
(function () {
  if (window.__rvInit) return;
  window.__rvInit = true;

  // comparador antes/depois
  document.addEventListener('input', function (e) {
    var r = e.target;
    if (!r.classList || !r.classList.contains('rv-cmp__range')) return;
    var box = r.closest('.rv-cmp');
    if (box) box.style.setProperty('--pos', r.value + '%');
  });

  // todos os CTAs abrem o formulário COD (Releasit)
  function codButton() {
    var sels = ['#_rsi-buy-now-button-overwrite', '._rsi-buy-now-button', '[class*="rsi-buy-now-button"]'];
    for (var i = 0; i < sels.length; i++) {
      var list = document.querySelectorAll(sels[i]);
      for (var j = 0; j < list.length; j++) if (list[j].offsetHeight > 0) return list[j];
    }
    return null;
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-rv-cod]') : null;
    if (!t) return;
    e.preventDefault();
    // leva o cliente ao topo do produto (acima do FAQ); NÃO abre o checkout — só o botão do próprio topo abre
    var blk = document.querySelector('.rvh'), hero = blk && (blk.closest('.shopify-section') || blk);
    if (hero) {
      var nav = document.querySelector('.rv-nav'), off = (nav ? nav.offsetHeight : 0) + 8;
      window.scrollTo({ top: hero.getBoundingClientRect().top + window.pageYOffset - off, behavior: 'smooth' });
      return;
    }
    var top = document.querySelector('.product, main');   // sem o topo do produto na página: só rola, nunca abre o checkout
    if (top) top.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // menu rápido fixo: o wrapper da seção precisa ser o sticky, abaixo do header do tema
  function hdr() { return document.querySelector('#shopify-section-header, header.header, header'); }
  function place() {
    var h = hdr(), top = 0;
    if (h) { var b = h.getBoundingClientRect().bottom; top = Math.max(0, Math.round(b)); }
    document.querySelectorAll('[data-rv-sticky]').forEach(function (el) {
      var w = el.closest('.shopify-section') || el;
      w.style.position = 'sticky'; w.style.top = top + 'px'; w.style.zIndex = 20;
    });
  }
  var tick = false;
  function sched() { if (tick) return; tick = true; requestAnimationFrame(function () { tick = false; place(); }); }
  window.addEventListener('scroll', sched, { passive: true });
  window.addEventListener('resize', sched);
  document.addEventListener('DOMContentLoaded', place);
  document.addEventListener('shopify:section:load', place);
  place();

  // links do menu: rolagem suave descontando header + menu
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('.rv-nav a[href^="#"]') : null;
    if (!a) return;
    var t = document.getElementById(a.getAttribute('href').slice(1));
    if (!t) return;
    e.preventDefault();
    var h = hdr(), off = (h ? h.getBoundingClientRect().height : 0) + 56;
    window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - off, behavior: 'smooth' });
  });
})();
